module.exports = __webpack_public_path__ + "static/media/Colette Straight Single Headboard - 90 cm_Teal.7b29f6b3.png";